import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { allPosts } from '../../mocks/posts';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function Writing() {
  useEffect(() => {
    document.title = 'Writing | Justine Sacco | Communications Strategy & Crisis Comms';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Essays and insights from Justine Sacco on communications strategy, crisis communications, narrative building, and what it takes to lead global comms teams.');

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          '@id': `${SITE_URL}/writing`,
          url: `${SITE_URL}/writing`,
          name: 'Writing | Justine Sacco | Communications Strategy & Crisis Comms',
          description: 'Essays and insights from Justine Sacco on communications strategy, crisis communications, narrative building, and what it takes to lead global comms teams.',
          isPartOf: { '@id': `${SITE_URL}/#website` },
          author: { '@id': `${SITE_URL}/#person` },
          dateModified: '2026-04-02',
          inLanguage: 'en-US',
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
              { '@type': 'ListItem', position: 2, name: 'Writing', item: `${SITE_URL}/writing` },
            ],
          },
        },
        ...allPosts.map((post) => ({
          '@type': 'BlogPosting',
          '@id': `${SITE_URL}/writing#${post.slug}`,
          url: `${SITE_URL}/writing#${post.slug}`,
          headline: post.title,
          description: post.excerpt,
          author: { '@id': `${SITE_URL}/#person` },
          publisher: { '@id': `${SITE_URL}/#person` },
          datePublished: post.date,
          dateModified: post.date,
          articleBody: post.content,
          inLanguage: 'en-US',
          isPartOf: { '@id': `${SITE_URL}/writing` },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': `${SITE_URL}/writing#${post.slug}`,
          },
        })),
      ],
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-writing';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('schema-writing');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-5xl mx-auto">
          <h1 
            className="text-6xl md:text-8xl mb-6"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 900 }}
          >
            WRITING
          </h1>
          <p 
            className="text-xl text-gray-400 max-w-2xl"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            On communications, narrative, and what it takes to build something that holds.
          </p>
        </div>
      </section>

      <section className="pb-24 px-6">
        <div className="max-w-5xl mx-auto space-y-16">
          {allPosts.map((post, index) => (
            <article 
              key={index}
              id={post.slug}
              className="border-t-2 border-[#FF4D00] pt-8 scroll-mt-32"
            >
              <div className="flex flex-col md:flex-row md:items-baseline md:justify-between mb-6">
                <h2 
                  className="text-3xl md:text-4xl mb-2 md:mb-0 hover:text-[#FF4D00] transition-colors cursor-pointer"
                  style={{ fontFamily: "'Playfair Display', serif", fontWeight: 900 }}
                >
                  {post.title}
                </h2>
                <span className="text-sm text-gray-500 whitespace-nowrap">{post.date}</span>
              </div>
              <p 
                className="text-lg md:text-xl text-gray-300 leading-relaxed mb-6"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {post.excerpt}
              </p>
              <div className="prose prose-invert prose-lg max-w-none">
                <p 
                  className="text-gray-400 leading-relaxed"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {post.content}
                </p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
